export default function assertIsDefined<T>(val: T, msg?: string): asserts val is NonNullable<T> {
  if (val === undefined || val === null) {
    throw new Error(msg ?? `Expected 'val' to be defined, but received ${val}`);
  }
}
